<template>
  <main class="search-bar-container">
    <form @submit.prevent="onSearch" class="search-form">
      <button 
        type="button"
        id="catalog-search-btn" 
        class="fa fa-search icon-magnifier" 
        style="cursor: pointer;"
        @click="onSearch"
        aria-label="Search, button"
        >
      </button>
      <input
        type="text"
        v-model="query"
        class="search-input"
        :placeholder="placeholder"
        aria-label="Search, edit text"
      />
      <button v-if="query"
        type="button"
        id="catalog-search-clear-btn" 
        class="icon-modal-close"
        style="cursor: pointer;"
        @click="clearInput"
        >
      </button>
    </form>
    <button 
        v-if="showCancel"
        type="button"
        class="cancel-btn"
        style="cursor: pointer;"
        @click="cancelSearch"
        aria-label="Clear search"
      >Cancel
    </button>
  </main>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      query: this.modelValue || "",
      placeholder: "Search Catalog",
      previousUrl: "/",
    };
  },
  computed: {
    showCancel() {
      return window.location.pathname.includes("/catalog-search");
    },
  },
  watch: {
    modelValue(newValue) {
      this.query = newValue;
    },
    query(newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
  mounted(){
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get("query");
    if (queryParam && !this.modelValue) {
      this.query = queryParam;
    }

    //remember URL
    const referrer = document.referrer;
    const storedPreviousUrl = localStorage.getItem("previousUrl");

    if (window.location.pathname.includes("/catalog-search")) {

      if (window.location.pathname.includes("/catalog-search")) {
        if (referrer && !referrer.includes("/catalog-search")) {
          this.previousUrl = referrer;
          localStorage.setItem("previousUrl", referrer);
        } else if (storedPreviousUrl) {
          this.previousUrl = storedPreviousUrl;
        }
      } else {
        localStorage.setItem("previousUrl", window.location.href);
      }
    }
    
  },
  methods: {
    onSearch() {
      if (this.query.trim()) {
        window.location.href = `/rewards-catalog/catalog-search?query=${encodeURIComponent(this.query)}`;
      }
    },
    clearInput() {
      this.query = "";
    },
    cancelSearch() {
      window.location.href = this.previousUrl;
    },
  },
};
</script>